export default "__VITE_ASSET__BJZMcEuZ__"